import React from "react";
import { useParams } from "react-router-dom";
import Seo from "../components/Seo";
import PageIntro from "../components/qa/PageIntro";
import ProjectPreview from "../components/qa/ProjectPreview";
import { getCopy } from "../content/portfolio";
import { getQaProject, projectKeys } from "../content/qaProjects";

export default function Projects() {
  const { locale = "de" } = useParams();
  const copy = getCopy(locale);
  const projects = projectKeys.map(key => getQaProject(locale, key));
  const url = `https://antonrost.de/${locale}/projects/`;
  const schema = [{
    "@context": "https://schema.org", "@type": "CollectionPage", name: copy.projectsPage.title,
    description: copy.projectsPage.intro, url,
    mainEntity: { "@type": "ItemList", itemListElement: projects.map((project, index) => ({ "@type": "ListItem", position: index + 1, name: project.title, url: `${url}${project.slug}` })) }
  }];
  return (
    <div className="page-wrapper">
      <Seo locale={locale} metadata={copy.projectsPage.seo} path="/projects/" schema={schema} />
      <PageIntro titleId="projects-title" eyebrow={copy.projectsPage.eyebrow} title={copy.projectsPage.title} intro={copy.projectsPage.intro} note={copy.projectsPage.note} />
      <section className="content-wrapper" aria-label={copy.home.projectsTitle}>
        <div className="qa-project-grid">{projectKeys.map(key => <ProjectPreview key={key} locale={locale} projectKey={key} />)}</div>
      </section>
    </div>
  );
}
